import { render, staticRenderFns } from "./ModalForm.vue?vue&type=template&id=42ebda3e&scoped=true&"
import script from "./ModalForm.vue?vue&type=script&lang=ts&"
export * from "./ModalForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ebda3e",
  null
  
)

export default component.exports